import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchTags, deleteTag } from "actions/tag";
import { toggleconfirmationPopup, toggleNotification } from "actions/toggle";

import Pagination from "components/Pagination";
import Table from "./Table";
import SearchForm from "./SearchForm";

class TagIndex extends Component {
  componentDidMount() {
    this._fetchTags();
    this.search = {};
    this.page = 1;
  }

  _fetchTags() {
    const { companyURL: company_url } = this.props.match.params;
    this.props.fetchTags({ company_url, partials: "categories", ...this.search, page: this.page });
  }

  onSearchFormSubmit = data => {
    this.search = { [data.search_by]: data.search_term };
    this.page = 1;
    this._fetchTags();
  };

  onPaginationClick = page => event => {
    this.page = page;
    this._fetchTags();
  };

  handleTagDelete = id => event => {
    const { toggleconfirmationPopup } = this.props;
    toggleconfirmationPopup(true, {
      title: "Remove Tag",
      body: "Are you sure you want to remove this tag from company?",
      onClickConfirm: () => {
        this.deleteTagProcess(id);
      }
    });
  };

  deleteTagProcess(id) {
    const { toggleNotification, toggleconfirmationPopup, deleteTag, match } = this.props;
    const { companyURL: company_url } = match.params;
    deleteTag(id, { company_url })
      .then(() => {
        this._fetchTags();
        toggleNotification(true, { infoClassName: "is-success", message: "Delete Tag Success" });
      })
      .catch(({ message }) => {
        toggleNotification(true, { infoClassName: "is-danger", message });
      })
      .then(() => toggleconfirmationPopup(false, {}));
  }

  render() {
    const { tags, match } = this.props;
    const { companyURL } = match.params;

    return (
      <div>
        <div className="box">
          <SearchForm onSearchFormSubmit={this.onSearchFormSubmit} />

          <Table tags={tags} companyURL={companyURL} onClickDelete={this.handleTagDelete} />
          <Pagination
            onClick={this.onPaginationClick}
            currentPage={tags.current_page}
            lastPage={tags.last_page}
            range="4"
            modifyClasses="is-right"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ tags, articles, confirmationPopupActive }) => ({
  tags,
  articles,
  confirmationPopupActive
});

export default connect(
  mapStateToProps,
  { fetchTags, deleteTag, toggleconfirmationPopup, toggleNotification }
)(TagIndex);
